<div class="toolbar flex flex-row content-center items-center justify-stretch">
  <a class="logo-icon" routerLink="/admin/operators">
    <mat-icon [svgIcon]="SparrowIcon.SparrowIcon" />
  </a>
  <div class="header-buttons flex flex-row">
    <a routerLink="/admin/operators" routerLinkActive="active">Operators</a>
    <a routerLink="/admin/suppliers" routerLinkActive="active">Suppliers</a>
    <a routerLink="/admin/erp" routerLinkActive="active">ERP</a>
    <button #matMenuTrigger="matMenuTrigger" #menuTrigger [matMenuTriggerFor]="catalogueMenu">
      <div class="flex flex-row content-center items-center gap-2">
        <div class="flex flex-col">
          <div class="username">Catalogue Management</div>
        </div>
        <mat-icon
          [ngClass]="{ 'rotate-180': matMenuTrigger.menuOpen }"
          [svgIcon]="SparrowIcon.CaretDown"
          class="size-5! transition-transform duration-500"
        />
      </div>
    </button>
    <a routerLink="/admin/user-management" routerLinkActive="active">User Management</a>
    <a routerLink="/admin/catalogue-management" routerLinkActive="active">DC</a>
    <a routerLink="/admin/user-manager" routerLinkActive="active">User Manager</a>
    <div class="flex flex-auto"></div>
    <div class="sp-body-3 mr-6 h-full self-center opacity-70">{{ fullName }}</div>
    <button (click)="logout()" class="flex flex-row content-center items-center gap-2">
      <mat-icon [svgIcon]="SparrowIcon.SignOut" />
      <span>Logout</span>
    </button>
  </div>
</div>

<mat-menu #catalogueMenu="matMenu" [overlapTrigger]="false" class="named-view-menu" xPosition="after">
  <!-- The width of the menu is set to match the width of the button -->
  <div
    [ngStyle]="{ width: menuTrigger.clientWidth + 'px' }"
    class="flex flex-col content-stretch items-stretch justify-start"
  >
    <a class="drop-option" mat-menu-item routerLink="/admin/brands">Brands</a>
    <a class="drop-option" mat-menu-item routerLink="/admin/catalog">Catalogues</a>
    <a class="drop-option" mat-menu-item routerLink="/admin/definitions">Definitions</a>
    <a class="drop-option" mat-menu-item routerLink="/admin/extraction-patterns">Patterns</a>
    <a class="drop-option" mat-menu-item routerLink="/admin/catalogue-search">Search</a>
  </div>
</mat-menu>
